<pagination-template #p="paginationApi" class="pagination_container" (pageChange)="pageChange.emit($event)">
    <!-- First Page Button -->
    <div *ngIf="firstLastEnable" class="pagination-first" [class.disabled]="p.isFirstPage()">
        <a (click)="!p.isFirstPage() && p.setCurrent(1)" [class.disabled]="p.isFirstPage()"><img src="../../../../assets/icons/double-chevron-right.svg" alt="" width="16" class="double-chevron"></a>
    </div>

    <!-- Previous Button (Disabled when on First Page) -->
    <div class="pagination-previous" [class.disabled]="p.isFirstPage()">
        <a data-cy="pagination-previous" (click)="!p.isFirstPage() && p.previous()" [class.disabled]="p.isFirstPage()">
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="chevron-left">
                    <path id="Vector" d="M10 13.8232L5 8.82324L10 3.82324" stroke="#4F4F4F" style="stroke:#4F4F4F;stroke:color(display-p3 0.3098 0.3098 0.3098);stroke-opacity:1;"
                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </g>
            </svg>
        </a>
    </div>

    <!-- Page Numbers with Active Page Styling -->
    <div *ngFor="let page of p.pages">
        <a class="page__number" [attr.data-cy]="'pagination-page-' + page.value" [class.active]="p.getCurrent() === page.value" [attr.data-active]="p.getCurrent() === page.value"
            (click)="p.setCurrent(page.value)" *ngIf="page.value">
            <span>{{ page.label }}</span>
        </a>
        <div *ngIf="!page.value">
            <span>{{ page.label }}</span>
        </div>
    </div>

    <!-- Next Button (Disabled when on Last Page) -->
    <div class="pagination-next" [class.disabled]="p.isLastPage()">
        <a data-cy="pagination-next" (click)="!p.isLastPage() && p.next()" [class.disabled]="p.isLastPage()">
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="chevron-right">
                    <path id="Vector" d="M6 3.82324L11 8.82324L6 13.8232" stroke="#4F4F4F" style="stroke:#4F4F4F;stroke:color(display-p3 0.3098 0.3098 0.3098);stroke-opacity:1;"
                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </g>
            </svg>
        </a>
    </div>

    <!-- Last Page Button -->
    <div *ngIf="firstLastEnable" class="pagination-last" [class.disabled]="p.isLastPage()">
        <a (click)="!p.isLastPage() && p.setCurrent(totalPages)" [class.disabled]="p.isLastPage()"><img src="../../../../assets/icons/double-chevron-right.svg" alt="" width="16"></a>
    </div>
</pagination-template>